import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

// Check if we're in demo mode
const isDemo = process.env.REACT_APP_IS_DEMO === 'true';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handlePlaceholderClick = (option) => {
    alert(`${option} is coming soon!`);
    setMenuOpen(false);
  };

  return (
    <header
      style={{
        background: 'transparent',
        padding: '0 24px 0 0',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-start',
        position: 'relative',
        zIndex: 100,
      }}
    >
      <div style={{ position: 'relative' }}>
        <button
          onClick={toggleMenu}
          aria-label="Open menu"
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            width: '30px',
            height: '22px',
            padding: 0,
            outline: 'none',
          }}
        >
          <span
            style={{
              display: 'block',
              width: '100%',
              height: '4px',
              backgroundColor: '#e0e0e0',
              borderRadius: '2px',
              transition: 'transform 0.3s ease',
              transform: menuOpen ? 'rotate(45deg) translate(5px, 6px)' : 'none',
            }}
          ></span>
          <span
            style={{
              display: 'block',
              width: '100%',
              height: '4px',
              backgroundColor: '#e0e0e0',
              borderRadius: '2px',
              opacity: menuOpen ? '0' : '1',
              transition: 'opacity 0.3s ease',
            }}
          ></span>
          <span
            style={{
              display: 'block',
              width: '100%',
              height: '4px',
              backgroundColor: '#e0e0e0',
              borderRadius: '2px',
              transition: 'transform 0.3s ease',
              transform: menuOpen ? 'rotate(-45deg) translate(7px, -7px)' : 'none',
            }}
          ></span>
        </button>
        {menuOpen && (
          <div
            style={{
              position: 'absolute',
              top: '40px',
              right: '0',
              backgroundColor: '#2d3748',
              borderRadius: '6px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
              zIndex: 1000,
              minWidth: '180px',
              fontFamily: 'Poppins, sans-serif',
              overflow: 'hidden',
            }}
          >
            <Link
              to="/feedback"
              onClick={() => setMenuOpen(false)}
              style={{
                display: 'block',
                padding: '14px 24px',
                color: '#e0e0e0',
                textDecoration: 'none',
                fontFamily: 'Poppins, sans-serif',
                fontSize: '15px',
                borderBottom: isDemo ? 'none' : '1px solid #4a5568',
                background: 'none',
                transition: 'background 0.2s',
              }}
            >
              Submit Feedback
            </Link>
            {!isDemo && (
              <Link
                to="/account-settings"
                onClick={() => setMenuOpen(false)}
                style={{
                  display: 'block',
                  padding: '14px 24px',
                  color: '#e0e0e0',
                  textDecoration: 'none',
                  fontFamily: 'Poppins, sans-serif',
                  fontSize: '15px',
                  background: 'none',
                  transition: 'background 0.2s',
                }}
              >
                Account Settings
              </Link>
            )}
          </div>
        )}
      </div>
    </header>
  );
}

export default Header; 